import { Deserializable } from '../interfaces';

export class UploadService implements Deserializable {
  imagen: File | null;
  documento: File | null;
  idServicio: number;
  idTarjeta: number;
  idTipoServicio: number;
  nombreServicio: string;
  urlIcono: string;
  descripcion: string;
  urlServicio: string;
  urlDocumento: string;
  urlImagen: string;
  idUsuario: number;
  idioma: string;
  posicion: number;

  constructor() {
    this.imagen = null;
    this.documento = null;
    this.idServicio = 0;
    this.idTarjeta = 0;
    this.idTipoServicio = 0;
    this.nombreServicio = '';
    this.urlIcono = '';
    this.descripcion = '';
    this.urlServicio = '';
    this.urlDocumento = '';
    this.urlImagen = '';
    this.idUsuario = 0;
    this.posicion = 0;
    this.idioma = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
